import { button } from "./fragments/button.js";
import { header } from "./blocks/header.js";
import { initCopyBtn } from "./fragments/copyBtn.js";
import { initScrollContainer } from "./fragments/scrollContainer.js";
import { initAccord } from "./fragments/accord.js";
import { initTabs } from "./fragments/tabs.js";
import { initModal } from "./blocks/modal.js";
import { initSlots } from "./fragments/slots.js";
import { initIframeBlock } from "./fragments/iframeBlock.js";
import { initGoUp } from "./fragments/go-up.js";
import { initThemeSwitcher } from "./fragments/themeSwitcher.js";
import { faq } from "./fragments/faq.js";
import { demo } from "./fragments/demo.js";